// extracted by mini-css-extract-plugin
export var aboutTabs = "VideoInfo-module--aboutTabs--996be";
export var cyan = "VideoInfo-module--cyan--733f7";
export var description = "VideoInfo-module--description--cf326";
export var descriptionExpanded = "VideoInfo-module--descriptionExpanded--24055";
export var red = "VideoInfo-module--red--21248";
export var root = "VideoInfo-module--root--7c6c7";